<ng-container *ngVar="selectionService?.isObjectSelected(selectionConfig?.listId, object) | async as checked">
  <span class="form-check">
    @if (selectionConfig.repeatable) {
      <input #selectListItemCheckbox class="form-check-input" type="checkbox"
        [attr.aria-label]="(selectListItemCheckbox.checked ? 'selectable-list-item-control.deselect' : 'selectable-list-item-control.select') | translate"
        [name]="'checkbox' + index"
        [id]="'object' + index"
        [ngModel]="selected$ | async"
        (ngModelChange)="selectCheckbox($event)">
    }
    @if (!selectionConfig.repeatable) {
      <input class="form-check-input mt-2" type="radio"
        [attr.aria-label]="'selectable-list-item-control.select' | translate"
        [name]="'radio' + index"
        [id]="'object' + index"
        [checked]="selected$ | async"
        (click)="selectRadio(!checked)">
    }
  </span>
</ng-container>
